import {DestroyRef, Directive, EmbeddedViewRef, inject, OnInit, Pipe, PipeTransform} from '@angular/core';
import {Observable, of} from "rxjs";
import {TranslocoDirective, TranslocoService} from "@jsverse/transloco";
import {mergeMap} from "rxjs/operators";
import {isNullOrWhiteSpace} from '../../helpers/string-helper';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Directive({
  selector: '[transloco]',
  standalone: true,
})
export class LeTranslocoDirective implements OnInit {
  private destroyRef = inject(DestroyRef);
  private service = inject(TranslocoService);
  view: EmbeddedViewRef<any> | undefined;

  constructor(private translocoDirective: TranslocoDirective) {
  }

  ngOnInit(): void {
    this.service.langChanges$
      .pipe(takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        if (this.translocoDirective.view) {
          let $implicit = this.translocoDirective.view.context.$implicit;
          this.translocoDirective.view.context.$implicit = (key, params) => {
            params = params ?? {};
            params['prefix'] = params['prefix'] ?? this.translocoDirective.prefix ?? this.translocoDirective.inlineRead;
            return $implicit(key, params);
          };
        }
      });
  }
}

@Pipe({
  name: 'localizedValue',
  standalone: true
})
export class LocalizedValuePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {
  }

  transform(value: string, prefix: string, suffix: string, defaultValue: string): Observable<string> {

    if (value == null) {
      return of(defaultValue);
    }

    let keys = [prefix, value.replace(/ /g, '-'), suffix].filter(value1 => !isNullOrWhiteSpace(value1));
    const key = keys.join('.');
    return this.translocoService.selectTranslate(key, {prefix: prefix}).pipe(mergeMap(byKey => {
      if (byKey == keys.slice(1).join('.')) {
        return of(defaultValue)
      }
      return of(byKey as string);
    }));
  }

}
